import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { CommonLoader } from "../../../common/CommonLoader";
import { formatAmount } from "../../../../services/utils";

const PaperStatsChartLineSilo = ({ visibleKeys, data, fetching, year, frequency, activeTab, activeTabTypeSilo }) => {

  const getCurrentYearMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    return `${year}-${month}`;
  }

  const formatDataColor = (data) => {
    const result = {};

    Object.values(data).forEach(monthData => {
      Object.values(monthData).forEach(silot => {
        const { silotId, silotName, color } = silot;

        if (!result[silotId]) {
          result[silotId] = {
            silotId,
            silotName,
            color,
          };
        }
      });
    });

    return result;

  };

  const formatData = () => {

    const NbrInscrit = [];
    const Ca = [];

    if (frequency === "MONTHLY") {
      Object.entries(data).forEach(([monthKey, silots]) => {
        const [year, month, day] = monthKey.split("-");
        const formattedMonth = `${month}/${year}`;

        const nbrInscritObj = { name: formattedMonth, total: 0 };
        const caObj = { name: formattedMonth, total: 0 };

        Object.values(silots).forEach(silot => {
          const totalNbrInscrit = silot.individuelNbrInscrit + silot.fiduciareNbrInscrit;
          const totalCa = silot.individuelCa + silot.fiduciareCa;

          nbrInscritObj[silot.silotName] = totalNbrInscrit;
          caObj[silot.silotName] = totalCa / 100;
          nbrInscritObj['total'] += totalNbrInscrit;
          caObj['total'] += totalCa / 100;
        });

        NbrInscrit.push(nbrInscritObj);
        Ca.push(caObj);
      });
    }

    if (frequency === "DAILY") {
      Object.entries(data).forEach(([dayKey, silots]) => {
        const [year, month, day] = dayKey.split("-");
        const formattedDay = `${day}/${month}`;

        const nbrInscritObj = { name: formattedDay, total: 0 };
        const caObj = { name: formattedDay, total: 0 };

        Object.values(silots).forEach(silot => {
          const totalNbrInscrit = silot.individuelNbrInscrit + silot.fiduciareNbrInscrit;
          const totalCa = silot.individuelCa + silot.fiduciareCa;

          nbrInscritObj[silot.silotName] = totalNbrInscrit;
          caObj[silot.silotName] = totalCa / 100;
          nbrInscritObj['total'] += totalNbrInscrit;
          caObj['total'] += totalCa / 100;
        });

        NbrInscrit.push(nbrInscritObj);
        Ca.push(caObj);
      });
    }

    if (frequency === "YEARLY") {
      // ============================
    }

    return activeTab === "chiffreAffaire" ? Ca : NbrInscrit;

  };
  const chartData = formatData();
  const coloredData = formatDataColor(data);

  console.log('=== chartData ===', chartData);
  console.log('=== coloredData ===', coloredData);

  return (
    <React.Fragment>
      {fetching ? <div style={{ width: '100%' }}><CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} /></div> : (
        <ResponsiveContainer width={'100%'} height={300}>
          <LineChart
            data={chartData}
            margin={{
              top: 10,
              right: 30,
            }}
            style={{
              fontSize: '12px',
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 400
            }}
          >
            <CartesianGrid stroke="#D8DDE2" vertical={false} strokeDasharray="4" />
            <XAxis dataKey="name" tickMargin={10} axisLine={false} tickLine={false} tick={{ fill: '#6D7F92' }} />
            <YAxis tickMargin={10} axisLine={false} tickLine={false} tick={{ fill: '#6D7F92' }} allowDecimals={false} />
            <Tooltip
              contentStyle={{ 'borderRadius': '5px' }}
              itemStyle={{ textTransform: "capitalize" }}
              formatter={activeTab === 'chiffreAffaire' ? (value) => formatAmount(value, false) : (value) => value}
            />

            {
              coloredData && Object.values(coloredData).map((silo) => (
                visibleKeys.includes(silo.silotId) &&
                <Line
                  dataKey={silo.silotName}
                  stroke={silo.color}
                  activeDot={{ r: 8 }}
                  type='linear'
                  dot={{ stroke: silo.color, strokeWidth: 6 }}
                />
              ))
            }

            <Line
              dataKey="total"
              stroke="#000"
              activeDot={{ r: 8 }}
              type='linear'
              dot={{ stroke: '#000', strokeWidth: 6 }}
            />

          </LineChart>
        </ResponsiveContainer>
      )}
    </React.Fragment>
  );
}

export default PaperStatsChartLineSilo;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/PaperStatsChartLineSilo.js